import React, { useEffect, useState } from 'react'
import { app, database } from '../Firebase/firebase'
import firebase from "firebase/compat/app";
import 'firebase/database'
import { getDatabase, ref, set, child, get} from "firebase/database"
import './Styles/Register.css'
import { TextField } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function Register(props){

    const {slug} = useParams()
    const db = ref(getDatabase())
    const database = getDatabase()
    const [event, setEvent] = useState({
        title: 'EVENT NAME',
        phone: '6942069420',
        round: '1',
        rules: 'Duis eu pretium mauris. Nulla semper rutrum eros, nec laoreet neque laoreet vel. Quisque molestie, mi nec dictum tincidunt, dui ex egestas massa, pharetra fermentum lacus libero id lorem. Maecenas semper augue vel blandit aliquam. Duis viverra, ex blandit eleifend cursus, eros neque varius lorem, in porta ex nulla id augue. Sed sit amet finibus dolor. Etiam suscipit nisi nec orci egestas, consectetur semper nisi eleifend. Maecenas tincidunt at leo sit amet malesuada. In leo tellus, pretium eu pretium vitae, mattis vitae dolor. In suscipit arcu sed ligula iaculis sollicitudin ut sit amet dui. Aenean egestas, erat a malesuada consectetur, leo velit laoreet libero, quis ultricies nibh ipsum in felis. Aliquam vel malesuada tortor, ac vehicula mauris.',
        team: 'team',
        techorno: 'technical',
        time: 'dynamic',
        incharge: 'Names'
    })

    useEffect(() => {
        get(child(db, '/contestList/'+slug)).then(snap=>{
            setEvent(snap.val())
        }).catch(e=>{
            console.log(e)
        })
    }, [])

    const [name, setName] = useState('')
    const [mail, setMail] = useState('')
    const [reg, setReg] = useState('')
    const [phone, setPhone] = useState()
    const [college, setCollege] = useState('')

    function handleSubmit(){
        const data = {
            name: name,
            phone: phone,
            mail: mail,
            reg: reg,
            college: college
        }
        set(ref(database, 'registrationList/'+slug+'/'+phone), data).then(()=>{alert('ok')})
    }

    function handleName(e){
        setName(e.target.value)
    }

    function handleMail(e){
        setMail(e.target.value)
    }

    function handleReg(e){
        setReg(e.target.value)
    }

    function handlePhone(e){
        setPhone(e.target.value)
    }

    function handleCollege(e){
        setCollege(e.target.value)
    }

    return(
        <div className='register'>
            <div className='details'>
                <div className='hwrapper'>
                    <div className='heading'>{slug}</div>
                </div>
                <div className='edesc'>{event.rules}</div>
                <div className='ecol'>
                <table>
                    <tr>
                        <td className='left'>Venue</td>
                        <td>{event.round}</td>
                    </tr>
                    <tr>
                        <td className='left'>Timing</td>
                        <td>{event.time}</td>
                    </tr>
                    <tr>
                        <td className='left'>Incharge</td>
                        <td>{event.incharge}</td>
                    </tr>
                    <tr>
                        <td className='left'>Contact</td>
                        <td>{event.phone}</td>
                    </tr>
                </table>
                </div>
            </div>
            <div className='datas'>
                <input type='text' id='name' placeholder='Name' onChange={handleName}/>
                <input type='text' id='college' placeholder='College' onChange={handleCollege}/>
                <input type='text' id='reg' placeholder='Register No.' onChange={handleReg}/>
                <input type='number' id='phone' placeholder='Phone' onChange={handlePhone}/>
                <input type='text' id='mail' placeholder='Email ID' onChange={handleMail}/>
                <div className='seew'><button className='seebtn' onClick={handleSubmit}>Register for this event</button></div>
            </div>
        </div>
    )
}